/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import nl2br from 'react-nl2br';
import {CUSTOM_DATA_TYPE_NOTE} from '../../../../common/model-api/CustomDataType';
import {ParentBox, relayWrap} from '../../box-utils/ParentBox.react.js';
import {viewWithDataGetPrimaryData} from '../../box-utils/PrimaryData';
import Error from '../system/Error.react.js';
import {sendError} from '../../../app/errorDisplayer';
import BoxDecorator from '../../box-utils/BoxDecorator.react';
import {FormattedMessage, FormattedRelative, defineMessages} from 'react-intl';
import config from '../../../../common/config';
import {Textarea, Form} from 'formsy-react-components';
import {ButtonToolbar, ButtonGroup, Button} from 'react-bootstrap';
import EditorSaver from '../../../fw/EditorSaver';
import types from '../../../../common/model-api/types';
import Relay from 'react-relay';
import LoadingButton from '../../../fw/LoadingButton.react';
import LoadingButtonNew from '../../../fw/LoadingButtonNew.react';

import './Notes.scss';
import {safeJSONparse} from "../../../../common/util/safeJSONparse";

const messages = defineMessages({
    textareaPlaceholder: {id: 'Notes.placeholder', 'defaultMessage': 'New note'},
	removeButton: {id: 'jsonTable.button.remove', 'defaultMessage': 'Remove'},
	removingButton: {id: 'jsonTable.button.removing', 'defaultMessage': 'Removing'},
	previewData1: {id: 'jsonTable.previewData.1', 'defaultMessage': 'This is my note.'},
	previewData2: {id: 'jsonTable.previewData.2', 'defaultMessage': 'This is my other note.'},
});

class Notes extends ParentBox {

    static handlerName = "notes";

    static propTypes = {
        intl: PropTypes.object.isRequired,
        isPreview: PropTypes.bool,
        viewWithData: PropTypes.object.isRequired,
    };

    getIcon() {
        return "dativery";
    }

	getServiceName() {
		return "Dativery";
	}

	constructor(props) {
        super(props);

        this.state = {
            newlyAdded: [],
            isAdding: false,
			isLoading: false,
			edit: null,
			deleting: false,
		};
    }

	getFatQuery() {
		if (this.state.edit) {
			return Relay.QL `fragment on UpdateCustomDataPayload {
	            updatedNode {
	                id,
	                content,
	            },
	        }`;
		}

		return Relay.QL `fragment on CreateCustomDataPayload {
			edge {
				node {
					id,
					realId,
					title,
					content,
					createdAt,
					author {
						id,
						nickname,
						firstname,
						surname,
						picture,
						email,
						locale
					}
				}
			},
		}`;
	}

	getMutation() {
		if (this.state.edit) {
			return Relay.QL `mutation { updateCustomData }`;
		}

		return Relay.QL `mutation { createCustomData }`;
	}

    submitForm = (toStore) => {
        let channelAddon = this.props.viewWithData.view.channelAddon;

        let allData = this.props.viewWithData.data ? safeJSONparse(this.props.viewWithData.data) : {};
        let row = allData.find((row) => row['channelId'] === channelAddon['channel_id']);

		let self = this;
		// eslint-disable-next-line max-params
        let fce = function (data, storeData, defaultValue, columns) {
            storeData['channelAddon_id'] = channelAddon['realId'];
            storeData['type'] = CUSTOM_DATA_TYPE_NOTE;
            storeData['organisation_id'] = channelAddon['organisation_id'];
            storeData['channel_id'] = channelAddon['channel_id'];
            storeData['content'] = JSON.stringify({
                content: toStore.content
            });
            storeData['key'] = row.key;

			if (self.state.edit) {
				storeData['id'] = self.state.edit.id;
			}

            return storeData;
        };

        let saver = new EditorSaver(types['customDatas'], this.getMutation(), this.getFatQuery(), null, this.state.edit ? null : EditorSaver.CREATE, fce);
        return saver.save({}).then((data) => {
			if (this.state.edit) {
				let index = this.data.findIndex((item) => {
					return item.id === this.state.edit.id;
				});
				this.data[index].content.content = safeJSONparse(data.updateCustomData.updatedNode.content).content;

				this.setState({
					isLoading: false,
					edit: false,
					isAdding: false,
				});
				return;
			}

            let newData = data.createCustomData.edge.node;
            this.setState({
                isLoading: false,
				edit: false,
                newlyAdded: [
                    ...this.state.newlyAdded, {
                        ...newData,
                        content: safeJSONparse(newData.content),
                    }
                ],
                isAdding: false
            });
        });
    };

    renderAdding(visible) {
		if (visible) {
			setTimeout(() => {
				document.querySelector('.notes-add-form textarea').focus();
			}, 0);
		}
		else {
			return null;
		}

        return (
            <div className={"notes-add-form " + (visible ? 'show' : 'hide')}>
                <Form
                    layout="elementOnly"
                    onValidSubmit={this.submitForm}
                >
                    <Textarea name="content" placeholder={this.props.intl.formatMessage(messages.textareaPlaceholder)} value={this.state.edit ? this.state.edit.content : ""}></Textarea>

					<ButtonToolbar>
						<LoadingButton className="btn btn-primary btn-sm" isLoading={this.state.isLoading} type="submit">
							{
								this.state.edit
									? <FormattedMessage defaultMessage="Save note" id="Notes.saveNote" />
									: <FormattedMessage defaultMessage="Add note" id="Notes.addNote" />
							}
						</LoadingButton>
						<button className="btn btn-link btn-sm" onClick={this.onClickCancel} type="button">
							<FormattedMessage defaultMessage="Cancel" id="Notes.cancel" />
						</button>
					</ButtonToolbar>
                </Form>
            </div>
        );
    }

    onClickAdding = () => {
        this.setState({
            isAdding: true,
			edit: false,
        });
    };

    onClickCancel = () => {
        this.setState({
            isAdding: false,
			edit: false,
        });
    };

	editNote(e) {
		let data = safeJSONparse(e.target.closest('button').getAttribute('data'));
		this.setState({
			isAdding: true,
			edit: data,
		});
	}

	removeNote(e) {
		this.setState({
			deleting: true
		});
		let data = safeJSONparse(e.target.closest('button').getAttribute('data'));
		let id = data.id;

		let fatQuery = Relay.QL `
                fragment on DeleteCustomDataPayload @relay(pattern: true) {
                    updatedNode {
                        id
                    }
                }
            `;

        let mutation = Relay.QL `mutation { deleteCustomData }`;
        let saver = new EditorSaver(types['customDatas'], mutation, fatQuery, null, EditorSaver.DELETE);

		let self = this;
		return saver.save({
			id: id
		}).then(() => {
			let index = self.data.findIndex((item) => {
				return item.id === id;
			});

			self.data.splice(index, 1);

			self.setState({
				deleting: false
			});
        });
	}

	getData() {
		if (this.state.newlyAdded && this.state.newlyAdded.length > 0) {
			let data = this.data || [];
			this.data = data.concat(this.state.newlyAdded);

			let self = this;
			setTimeout(() => {
				self.setState({
					newlyAdded: []
				});
			}, 0);

			return this.data;
		}

		if (this.data) {
			return this.data;
		}

		let data =  [];
		if (this.props.isPreview) {
            data = [
                {
                    id: '1',
                    content: {
                        content: this.props.intl.formatMessage(messages.previewData1),
                    },
                    author: {
                        firstname: 'Alex',
                        surname: 'Smith',
                        "picture": "https:\/\/www.dativery.com\/wp-content\/plugins\/dativery\/title\/profile.png?v=" + config.VERSION
                    },
					createdAt: new Date((new Date()).getTime() - 1000 * 60 * 10).toISOString()
                },
                {
                    id: '2',
                    content: {
                        content: this.props.intl.formatMessage(messages.previewData2),
                    },
                    author: {
                        firstname: 'Alex',
                        surname: 'Smith',
                        "picture": "https:\/\/www.dativery.com\/wp-content\/plugins\/dativery\/title\/profile.png?v=" + config.VERSION
                    },
					createdAt: new Date((new Date()).getTime() - 1000 * 60 * 5).toISOString()
                },
            ];
        } else {
            let allData = viewWithDataGetPrimaryData(this.props.viewWithData);
            let allAddons = this.props.viewWithData.addon ? safeJSONparse(this.props.viewWithData.addon) : {};
            let channelAddon = this.props.viewWithData.view.channelAddon;

            let myCustomData = {};
            if (allAddons.customData && allAddons.customData[channelAddon['realId']]) {
                myCustomData = allAddons.customData[channelAddon['realId']];
            }
            for (let row of allData) {
                if (row['channelId'] === channelAddon['channel_id']) {
                    if (myCustomData[row['key']]) {
                        for (let note of myCustomData[row['key']]) {
                            data.push(note);
                        }
                    }
                }
            }
        }

		this.data = data;
		return data;
	}

    render() {
		let data = this.getData();

        try {
            return (
                <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
                    <div className="NotesHeader"><strong><small><FormattedMessage defaultMessage="Notes" id="notes.title" />{" "}<button className="btn btn-xs btn-default" onClick={this.onClickAdding} style={this.state.isAdding ? {visibility: 'hidden'} : {}}><span className="fa fa-plus"/></button></small></strong></div>
                    <div className={"notes-table" + (this.state.isAdding ? ' adding' : '')}>
						{this.renderAdding(this.state.isAdding)}
                        {data.length === 0
							? (<div className="CenteredContent"><FormattedMessage defaultMessage="No note yet" id="Notes.empty" /></div>)
                            : data.map(item => {
								item.sortDate = new Date(item.createdAt);
								return item;
							}).sort((a, b) => {
								return a.sortDate - b.sortDate;
							}).map((row, idx) => {
                                return (
                                    <div className="notes-row boxSmall" key={idx}>
                                        <div className="notes-profile">
                                            <div className="fullContact-image">{row.author ? <div style={{backgroundImage: 'url(' + row.author.picture + ')'}} title={row.author.firstname + " " + row.author.surname}></div> : null}</div>
                                        </div>
                                        <div className="notes-content">
											<div className="top">
												<strong>{row.author.firstname + " " + row.author.surname}</strong> <span className="notes-date" title={row.sortDate.toLocaleString()}><i className="fa fa-circle"></i> <FormattedRelative value={row.createdAt} /></span>
											</div>
                                            {nl2br(row.content.content)}

                                            {!this.props.isPreview ? <ButtonGroup className="NotesControls">
												<Button bsStyle="info" data={JSON.stringify({id: row.id, content: row.content.content})} onClick={this.editNote.bind(this)}>
													<span className="fa fa-pencil"></span>
													<span className="title"><FormattedMessage defaultMessage="Edit" id="edit" /></span>
												</Button>
												<LoadingButtonNew
													className="btn btn-danger"
													data={JSON.stringify({id: row.id})}
													icon="fa-times"
													onClick={this.removeNote.bind(this)}
													progressText={this.props.intl.formatMessage(messages.removingButton)}
													text={this.props.intl.formatMessage(messages.removeButton)}
													type='button'
													vertical
													withoutDone
												/>
											</ButtonGroup> : null}
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                </BoxDecorator>
            );
        } catch (e) {
            sendError(e);
            return (<Error error={e} />);
        }
    }
}

export default relayWrap(Notes);
